export default __webpack_public_path__ + "static/media/frames_15x20.b9786ce9.jpg";